import More from './more-desc';
import Filters from './filters';
import __Product from './product.js';

(function (DOC) {

	var CORE = {
		className: 'category-section--form',

		elements: null,

		construct: function () {
			var elements = DOC.getElementsByClassName(CORE.className);
			var i = 0;

			if (!elements || elements === null || typeof elements !== 'object' || !('length' in elements) || !elements.length) {
			}else{
        CORE.elements = [];

        for (i; i < elements.length; i++) {
          CORE.elements[CORE.elements.length] = elements[i];
          Filters(elements[i]);
        }
      }

      var i = 0;
      var product = DOC.getElementsByClassName( 'product-form' );
      if (typeof product !== 'object' || product == null || !product.length) {
      }else{
        this.product = [];

        for (i; i < product.length; i++) {
          this.product[this.product.length] = product[i];

          // Une classe "__init" est ajouté à l'élement pour éviter de réconstruction les events JS dessus une seconde fois
          // Sans cela, la popup d'ajout au panier s'affichera plusieurs fois si l'on clique sur deux boutons d'ajout au panier dans
          // le listing produit
          if( !$( product[i] ).hasClass('__init') ){
            $( product[i] ).addClass('__init');
            __Product.Product($('body'), product[i]);
          }
        }
      }
    }

	};
	CORE.construct();
	More();

})(document);
